import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import {
	ModuleSearchField,
	SearchSelectField,
	SimpleTextField,
	DateField,
	useSettings,
	useUserData
} from 'app/main/components';

import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function TicketsDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();
	const dispatch = useDispatch();
	const userData = useUserData();

	const checkActivity = value => {
		if (!value) return;
		// "Chiuso" id:101, order:3
		if (value.tist_id === 101)
			dispatch(
				showFastAddDialog({
					model: { wore_tick_uid: props.model.tick_uid },
					module: 'workreports'
				})
			);
	};

	return (
		<>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TITLE */}
				<SimpleTextField
					name="tick_title"
					label={t('DETAILS_TICKETS_FIELD_TITLE')}
					value={props.model.tick_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 6 }}>
				{/* DATE FROM */}
				<DateField
					name="tick_d_from"
					label={t('DETAILS_TICKETS_FIELD_DATE_FROM')}
					value={props.model.tick_d_from}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 6 }}>
				{/* DATE TO */}
				<DateField
					name="tick_d_to"
					label={t('DETAILS_TICKETS_FIELD_DATE_TO')}
					value={props.model.tick_d_to}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* STATUS */}
				<SearchSelectField
					name="tick_tist_id"
					label={t('DETAILS_TICKETS_FIELD_STATUS')}
					systable="tickets_statuses"
					value={props.model.tick_tist_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					afterChange={checkActivity}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TYPE */}
				<SearchSelectField
					name="tick_tity_id"
					label={t('DETAILS_TICKETS_FIELD_TYPE')}
					systable="tickets_types"
					value={props.model.tick_tity_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* COMPANY */}
				<ModuleSearchField
					name="tick_comp_uid"
					label={t('DETAILS_TICKETS_FIELD_COMPANY')}
					module="companies"
					uid={props.model.tick_comp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* EXTERNAL CONTACT */}
				<ModuleSearchField
					name="tick_peop_uid"
					label={t('DETAILS_TICKETS_FIELD_PERSON')}
					module="people"
					uid={props.model.tick_peop_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER */}
				<ModuleSearchField
					name="tick_user_assigned_uid"
					label={t('DETAILS_TICKETS_FIELD_ASSIGNED_USER')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'not_equal', filt_value: 1 }]}
					uid={props.model.tick_user_assigned_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER 2 */}
				<ModuleSearchField
					name="tick_user_assigned_2_uid"
					label={t('DETAILS_TICKETS_FIELD_ASSIGNED_USER_2')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'equals', filt_value: 1 }]}
					uid={props.model.tick_user_assigned_2_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* INTERNAL NUMBER */}
				<SimpleTextField
					name="tick_internalnumber"
					label={t('DETAILS_TICKETS_FIELD_INTERNALNUMBER')}
					value={props.model.tick_internalnumber}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
